import React from 'react';

import { Icon } from '../../../core/ui';
import DateRangePicker from '../../../core/common/DateRangePicker';
import { useTranslation } from '../../../core/context/TranslationContext';

import { useFamily } from '../../family/context/FamilyContext';
import styles from './SpendingReports.module.css';

const SCOPES = [
  { value: 'mine', icon: 'fa-user', labelKey: 'scope.mine' },
  { value: 'family', icon: 'fa-users', labelKey: 'scope.family' },
];

/** Month range picker plus a Mine / Family toggle (shown only to family members). */
export default function SpendingToolbar({ range, onRangeChange, scope, onScopeChange }) {
  const { t } = useTranslation();
  const familyContext = useFamily();
  const hasFamily = Boolean(familyContext?.family);

  return (
    <div className={styles.toolbar}>
      {hasFamily && (
        <div className={styles.scope} role="group" aria-label={t('scope.label')}>
          {SCOPES.map((s) => (
            <button
              key={s.value}
              type="button"
              className={`${styles.scopeBtn} ${scope === s.value ? styles.scopeActive : ''}`}
              onClick={() => onScopeChange(s.value)}
              aria-pressed={scope === s.value}
            >
              <Icon name={s.icon} size="sm" />
              <span>{t(s.labelKey)}</span>
            </button>
          ))}
        </div>
      )}
      <DateRangePicker
        start={range.from}
        end={range.to}
        granularity="month"
        onChange={onRangeChange}
      />
    </div>
  );
}
